module.exports = __webpack_public_path__ + "img/808A5B_E0E1D4_2C4304_C5C7B0-256px.9f8265ac.png";